import './MobilePayForm.less'
import React, {useContext, useRef, useEffect} from "react";
import {TranslationsContext} from "contexts/translations-context";
import AdyenCheckout from '@adyen/adyen-web';
import '@adyen/adyen-web/dist/adyen.css';
import { setInfoMessage } from '../../../managers/client-log.manager';


export const MOBILE_PAY_FORM_POPUP = 'MOBILE_PAY_FORM_POPUP';

let checkoutObject = null;
let isRedirected = false;

export const MobilePayForm = ({
																adyenClientKey,
																adyenPaymentMethodsResponse,
																mobilePayRedirectAction,
																onMobilePaySubmit,
																onMobilePayRedirect
}) => {

	const paymentContainerRef = useRef(null);
	const redirectContainerRef = useRef(null);


	useEffect(() => {

		if(!paymentContainerRef?.current) return null;


		checkoutObject = new AdyenCheckout({
			locale: "da-DK", // The shopper's locale. For a list of supported locales, see https://docs.adyen.com/online-payments/components-web/localization-components.
			environment: "test", // When you're ready to accept live payments, change the value to one of our live environments https://docs.adyen.com/online-payments/components-web#testing-your-integration.
			clientKey: adyenClientKey, // Your client key. To find out how to generate one, see https://docs.adyen.com/development-resources/client-side-authentication. Web Components versions before 3.10.1 use originKey instead of clientKey.
			paymentMethodsResponse: adyenPaymentMethodsResponse, // The payment methods response returned in step 1.
		});
		setInfoMessage(`MobilePayForm: checkoutObject created: ${!!checkoutObject}`)

		//checkoutObject.create('mobilepay').mount(paymentContainerRef.current);
		onMobilePaySubmit(); // Trigger mobile pay flow automatically, without user click
	}, []);

	useEffect(() => {
		if(checkoutObject && mobilePayRedirectAction && redirectContainerRef?.current && !isRedirected){
			checkoutObject.createFromAction(mobilePayRedirectAction).mount(redirectContainerRef.current);
			isRedirected = true;
			onMobilePayRedirect();
		}
	});

	return (<div className="mobile-pay-form">
		<div ref={paymentContainerRef} className="payment-container"></div>
		<div ref={redirectContainerRef} className="redirect-container"></div>
	</div>);
}
